// This code runs after our blocks have been loaded and their scripts have been enqueued.
window.Alpine.start();
